import { render, staticRenderFns } from "./business-profile-create.vue?vue&type=template&id=b337503c&scoped=true&"
import script from "./business-profile-create.vue?vue&type=script&lang=js&"
export * from "./business-profile-create.vue?vue&type=script&lang=js&"
import style0 from "./business-profile-create.vue?vue&type=style&index=0&id=b337503c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337503c",
  null
  
)

export default component.exports